import { apiClient } from '@/services/ApiClient.js'

export default {
  getCities() {
    return apiClient.get('general/cities').then(response => {
      return response
    })
  },
  getCounties(cityId) {
    return apiClient.get('general/cities/' + cityId + '/counties').then(response => {
      return response
    })
  },
  getDistricts(countyId) {
    return apiClient.get('general/counties/' + countyId + '/districts').then(response => {
      return response
    })
  },
  getNeighborhoods(countyId) {
    return apiClient.get('general/counties/' + countyId + '/districts-and-neighborhoods').then(response => {
      return response
    })
  }
}
